import React from "react";

const OptionSelector = ({
  options,
  periodicity,
  setPeriodicity,
  periodicityError,
  onPeriodicityChange,
}) => (
  <>
    <div className="options-container">
      {options.map((option, index) => (
        <div className="options-row" key={index}>
          <button
            disabled={option.disabled}
            onClick={() => {
              if (!option.disabled) {
                setPeriodicity(option);
                if (onPeriodicityChange) onPeriodicityChange(option);
              }
            }}
            className={`periodicity-option
              ${periodicity === option.value ? "selected" : ""}
              ${option.disabled ? "disabled" : ""}`}
          >
            {option.label}
          </button>
        </div>
      ))}
    </div>
    {periodicityError && (
      <div className="error-message">{periodicityError}</div>
    )}
  </>
);

export default OptionSelector;
